import InputText from '../ReusableComponents/InputText'
import React, { useEffect, useState } from "react";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from '../components/Buttons';
import TextArea from '../ReusableComponents/TextArea';
import { mainTable } from '../css/Common';
import MainLayout from '../components/MainLayout';
import GridPage from '../components/GridPage';
import Loader from "../ReusableComponents/Loader";
import MainPopup from '../popup-containers/MainPopup';
import { ItemCategoryHeader } from '../components/HeaderAttribute';
import ItemsCategorypopup from '../popup-containers/ItemsCategorypopup';
import ErrorPopup from '../ReusableComponents/ErrorPopup';
import PopUpButtons from '../components/PopUpButtons'
import PopUpScreenTitle from '../components/PopUpScreenTitle';
import toast from 'react-hot-toast'
import { BindAPI, BindPostAPI, IUDAPI } from '../services/APIConnection';
import AutoDropDown from '../ReusableComponents/AutoCompleteDropDown';

const ItemsCategory = () => {

  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(true);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [popUpData, setPopUpData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [errors, setErrors] = useState({});
  const [MstItemCategoryId, setMstItemCategoryId] = useState("");
  const [rowIndex, setRowIndex] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [bindItems, setbindItems] = useState([{
  }]);

  const [bindItemType, setbindItemType] = useState([]);

  useEffect(() => {
    BindItemscategoryData();
  }, []);

  const BindItemscategoryData = async () => {

    const data = {
      mstClientId:mstClientId,
    };
setIsLoading(true)
    const response = await BindPostAPI( data,"ItemscategoryAPI/Binditemscategory")
    console.log("API Response:", response);
    if (response && response.data) {
      setbindItems(response.data.Table)

      const itemtype = response.data.Table1.map((item) => ({
        value: item.MstItemTypeId,
        label: item.ItemType,
    }));

    setbindItemType(itemtype);
setIsLoading(false)

    } else {
      setbindItems([]);
    }
  };

  var createdBy = sessionStorage.getItem("createdBy");

  var mstClientId = sessionStorage.getItem("MstClientId"); 

  const handleSubmit = async (rowIndex, flag) => {
    



    setSubmitBtnDisabled(true);
    setIsLoading(true);

    // to validate form when insert and update
    const isValid = validateForm();
    if (flag == 1 || flag == 2) {
      if (!isValid) {                 // if entered details are invalid
        setIsOpen(true);
        setIsLoading(false);
        setSubmitBtnDisabled(false);
      }
      if (isValid) {                     // if entered details are valid
        setIsOpen(false);
        setIsLoading(true);


        const data = {                     // data to be send to api, if add/update

          mstItemcategoryId: MstItemCategoryId ? MstItemCategoryId : 0,
          mstClientId:mstClientId,
          mstItemTypeId:formFields.itemtype,
          itemcategory: formFields.itemscategory,
          description: formFields.description,
          createdBy: createdBy,
          flag: flag,
        };
        const response = await IUDAPI([data], "ItemscategoryAPI/IUDitemscategory");
        if (flag == 1) {                                              //if flag ==1 , add
          if (response.data.Table[0].Result === 'S') {
            toast.success("Items Category Data Inserted Successfully", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          } else {
            toast.error("Items Category data insert Failed", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        } else if (flag == 2) {                     //if flag ==2 , update

          if (response.data.Table[0].Result === "M") {
            toast.success("Items Category data modified successfully! 👍", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          } else {
            toast.error("Items Category data modification failed 👎", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        }
      } else { setSubmitBtnDisabled(false); }
    } else {                                               // if flag is neither 1 or 2

      const data = {                                        //data to be send to api for 3-delete,4-active,5-inactive
        mstItemcategoryId: bindItems[rowIndex].MstItemCategoryId,
        createdBy: createdBy,
        flag: flag,
      };

      const response = await IUDAPI([data], "ItemscategoryAPI/IUDitemscategory");

      if (flag == 3) {                                            //if flag ==3 , delete
        if (response.data.Table[0].Result === 'D') {
          toast.success("Items Category Data Deleted Successfully", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Failed to delete Items Category", {
            duration: 3000,
            position: "top-center",
          });
        }
        setTimeout(cancel, 3000);
      } else if (flag == 4) {                                               //if flag ==4 , Active
        if (response.data.Table[0].Result === "B") {
          toast.success("Items Category Data Inactivated successfully", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Items Category Data Inactivated Failed", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }

      } else if (flag == 5) {                                                 //if flag ==4 ,inactive
        if (response.data.Table[0].Result === "UB") {
          toast.success("Items Category Data Activated Successfully", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Items Category Data Reason Activated Failed", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      }
    }

    console.log("Submit reason for lost:", formFields);
    // cancel();
  };


  const validateForm = () => {
    const newErrors = {};
    if (!formFields.itemtype) {
      newErrors.itemTypeError = "Select Item Type";
    }
    // Item Category validation
    if (!formFields.itemscategory) {
      newErrors.itemscategoryError = "Enter the Item Category";
    } else if (!/^[a-zA-Z0-9\s]+$/.test(formFields.itemscategory)) {
      newErrors.itemscategoryError = "Only alphabets and numbers are allowed.";
    }
  
    setFormFieldsError((prev) => ({ ...prev, ...newErrors }));
    return Object.keys(newErrors).length === 0;
  };

  const cancel = () => {

    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false)
    setSubmitBtnDisabled(false);
    setIsLoading(false);
    BindItemscategoryData();
    setSubmitBtnDisabled(false);

    setFormFields({
      itemtype:"",
    itemscategory: "",
    description: "",
    });

    setFormFieldsError({
      itemTypeError: "",
      itemscategoryError: "",
      descriptionError: "",
    });
    setErrors({});

  }

  const [formFieldsError, setFormFieldsError] = useState({
    itemTypeError:"",
    itemscategoryError: "",
    descriptionError: "",
  });
  const [formFields, setFormFields] = useState({
    itemtype:"",
    itemscategory: "",
    description: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormFields((prev) => ({ ...prev, [name]: value }));

    if (value.trim() !== "") {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };
  const handleitem = (rowIndex, flag) => {
    setRowIndex(rowIndex);
    setpopUpOpen(true);
    setPopUpData(bindItems[rowIndex]);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);

      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);

      setUnBlockDetails(true);
    }
    const rowData = bindItems[rowIndex];
    setMstItemCategoryId(bindItems[rowIndex].MstItemCategoryId);

    setPopUpData(rowData);





  };

  const handleEdit = (rowIndex) => {

    setRowIndex(rowIndex);
    setMstItemCategoryId(bindItems[rowIndex].MstItemCategoryId);
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setFormFields({
      ...formFields,
      itemtype: bindItems[rowIndex].MstItemTypeId,
      itemscategory: bindItems[rowIndex].ItemCategory,
      description: bindItems[rowIndex].Description,


    });
  }

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(false);
    setAddScreenTitle(true);
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const formattedName = name.charAt(0).toUpperCase() + name.slice(1);
  
    let errorMessage = value.trim() === "" ? `Enter the ${formattedName}.` : "";
  
    // ✅ Only for Item Category: check alphabets + numbers only
    if (name === "itemscategory" && value.trim() !== "" && !/^[a-zA-Z0-9\s]+$/.test(value)) {
      errorMessage = "Only alphabets and numbers are allowed.";
    }
  
    setFormFieldsError((prevErrors) => ({
      ...prevErrors,
      [`${name}Error`]: errorMessage,
    }));
  };

  return (


    <MainLayout pageName={"2"}>

      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Item Category"
          header={ItemCategoryHeader}
          records={bindItems}
          handleEdit={handleEdit}
          handleAction={handleitem}
          showAdd={showAdd}
          blockView={false}
        />
      )}
      {visibleAdd && (
        <>
          <div className="w-full">
            <div className="flex flex-col w-full">
              <div className={mainTable.clientMasterMainAdd}>
                <AddScreenTitle
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  title="Items Category"
                />
              </div>
            </div>

            <div className="mx-auto md:w-[500px] w-full">
              <div className="relative w-full h-full max-w-xl md:h-auto">
                <div className="relative bg-white rounded-lg shadow">
                  <div className="px-6 py-6 lg:px-8">
                    <form className="space-y-6" action="#">

                      <AutoDropDown
                        title="Item Type"
                        name="itemtype"
                        classStar="text-red-500"
                        options={bindItemType}
                        placeholder="Select"
                        Class="p-0"
                        selectedOption={bindItemType.find(
                          (x) => x.value === formFields.itemtype
                        )}
                        controlFunc={(selectedOption) => {
                          const value = selectedOption ? selectedOption.value : "";
                          setFormFields((prev) => ({
                            ...prev,
                            itemtype: value,
                          }));
                          setFormFieldsError((prev) => ({
                            ...prev,
                            itemTypeError: "",
                          }));
                        }}
                        controlFuncBlur={() => {
                          setFormFieldsError((prev) => ({
                            ...prev,
                            itemTypeError: !formFields.itemtype ? "Select Item Type" : "",
                          }));
                        }}
                        errorMessage={formFieldsError.itemTypeError}
                      />

                      <InputText
                        inputType="text"
                        title="Item Category"
                        name="itemscategory"
                        classStar="text-red-500"
                        controlFunc={handleInputChange}
                        controlFuncBlur={handleBlur}
                        content={formFields.itemscategory}
                        disabled={false}
                        errorMessage={formFieldsError.itemscategoryError} 
                        isRequired={true}

                      />

                      <TextArea
                        title="Description"
                        rows={7}
                        name="description"
                        content={formFields.description}
                        resize={false}
                        placeholder="Enter description"
                        controlFunc={(e) =>
                          setFormFields((prev) => ({
                            ...prev,
                            description: e.target.value,
                          }))
                        }
                        controlFuncBlur={() => { }}
                        disabled={false}
                        // tabIndex="0"
                        errorMessage={formFieldsError.descriptionError}
                      />

                      <div className="flex justify-center mt-6">
                        <Buttons
                          addScreenTitle={addScreenTitle}
                          updateScreenTitle={updateScreenTitle}
                          disabledBtn={submitBtnDisabled ? true : false}
                          viewSaveButton={false}
                          handleSubmit={handleSubmit}
                          cancel={cancel}

                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup  //Main Pop up
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={() => setpopUpOpen(false)}
      >
        <div>
          <PopUpScreenTitle  //Popup screen Title
            title="Items Category"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <ItemsCategorypopup data={popUpData} 
          
          itemTypeOptions={bindItemType}/>
        </div>

        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  )
}

export default ItemsCategory